/**
 * Crea la memoria dei dati per una visita della dashboard e la passa ai
 * widget. All'uscita dalla pagina si butta via.
 *
 * Tiene i numeri freschi da sola:
 * - ogni 5 minuti, se la pagina e' in primo piano, rilegge le fonti in uso
 *   e ricalcola la data di oggi (a mezzanotte la dashboard cambia giorno);
 * - quando una bozza di abbonamento cambia (emessa, eliminata) rilegge le bozze.
 */

import { useEffect, useMemo, useState, type ReactNode } from 'react';
import { creaCacheFonti } from '../../lib/dashboard/cacheFonti';
import { CARICATORI } from '../../lib/dashboard/fonti';
import { oggiRoma } from '../../lib/dataItalia';
import { SUBSCRIPTION_DRAFTS_CHANGED_EVENT } from '../../lib/subscriptionInvoiceUtils';
import { ContestoDati } from './contestoDati';

const OGNI_CINQUE_MINUTI = 5 * 60_000;

export function DatiDashboard({ children }: { children: ReactNode }) {
  // La memoria vive e muore con questo componente: non va chiusa a mano.
  // (Chiuderla all'uscita la rompeva in sviluppo, dove React smonta e
  // rimonta ogni componente una volta per scovare errori.)
  const [cache] = useState(() => creaCacheFonti(CARICATORI));
  const [oggi, setOggi] = useState(() => oggiRoma());

  useEffect(() => {
    const giro = setInterval(() => {
      setOggi(oggiRoma());
      if (document.visibilityState === 'visible') cache.ricaricaTutto();
    }, OGNI_CINQUE_MINUTI);
    const bozzeCambiate = () => cache.ricarica('bozzeAbbonamenti');
    window.addEventListener(SUBSCRIPTION_DRAFTS_CHANGED_EVENT, bozzeCambiate);
    return () => {
      clearInterval(giro);
      window.removeEventListener(SUBSCRIPTION_DRAFTS_CHANGED_EVENT, bozzeCambiate);
    };
  }, [cache]);

  const valore = useMemo(() => ({ cache, oggi }), [cache, oggi]);
  return <ContestoDati.Provider value={valore}>{children}</ContestoDati.Provider>;
}
